<template>
	<div
		class="ms-grid-viewer"
		:class="{
			isResizeActive: isResizeActive,
			'h-auto': maxHeight,
			'hide-border-last-row-on-scroll':
				gridOptions && gridOptions.hideLastRowBorderOnScroll,
		}"
	>
		<div
			v-if="isFirstFilter && (isShowContentHeader || !dataEmpty)"
			class="ms-content--header"
			ref="header"
			:class="[
				{
					'hide-scroll': scrollVisiable,
					'ms-content--header-noborder': !isBorderTh,
				},
				classContentHeader,
			]"
		>
			<div>
				<table class="ms-table">
					<thead class="ms-thead">
						<tr class="ms-tr" :class="isBorderTh ? '' : 'ms-tr-noborder'">
							<th
								v-if="multiple"
								class="ms-th multiple-cell fix-row ms-th-bg"
								:class="[
									{ 'grey-title': greyTitle },
									{ 'col-only-check': !widgetOptionsLeft },
								]"
							>
								<ms-checkbox
									:value="isCheckedMultiple"
									@click="changeCheckedMultiple"
									class="justify-center"
									checkOnly
									:disabled="multipleDisabled"
									v-tooltip="
										tooltipCheckboxMulti
											? {
													content: tooltipCheckboxMulti,
													placement: 'top-start',
											  }
											: {}
									"
								/>
							</th>
							<th
								class="ms-th serial-title"
								v-if="serial"
								:class="{ 'grey-title': greyTitle }"
							>
								{{ $t('i18nCommon.OrderNumber') }}
							</th>
							<th
								class="ms-th widget-title widget-title-left multiple-cell-widget ms-th-bg"
								v-if="widgetOptionsLeft"
								:class="[
									`text-${
										widgetOptionsLeft.align ? widgetOptionsLeft.align : 'right'
									}`,
									{ 'grey-title': greyTitle },
									{ 'fix-column-left': isScrollLeft },
								]"
								:style="[
									{ 'min-width': `${widgetOptionsLeft.width}px` },
									columnx.length > 0
										? { width: `${widgetOptionsLeft.width}px` }
										: null,
								]"
							>
								<span>{{ widgetOptionsLeft.title }}</span>
							</th>
							<ms-th-group
								ref="th"
								class="ms-th ms-th-group"
								v-for="(col, colIndex) in visibleColumns"
								:key="col.dataField"
								:col="col"
								:resizeCol="resizeCol"
								:customGridLayout="customGridLayout"
								:sortCol="sortCol"
								:truncateOverflow="truncateOverflow"
								@resizeOn="resizeActive"
								:class="[
									{ 'grey-title': greyTitle },
									visibleColumns && colIndex == visibleColumns.length - 1
										? 'ms-th-last-col'
										: '',
								]"
								@resizeOff="resizeClose"
								@sort="sort"
								:name="name"
								:sortCondition="sortCondition"
								@onClickiconAfterTitle="onClickiconAfterTitle"
								@buildFilter="buildFilterHeader"
								:filterHeaders="filterHeaders"
							>
							</ms-th-group>
							<th
								class="ms-th widget-title"
								v-if="widgetOptions"
								ref="headerRightWeight"
								:class="[
									`text-${widgetOptions.align ? widgetOptions.align : 'right'}`,
									{ 'grey-title': greyTitle },
								]"
								:style="[
									{ 'min-width': `${widgetOptions.width}px` },
									columnx.length > 0
										? { width: `${widgetOptions.width}px` }
										: null,
								]"
							>
								<span>{{ widgetOptions.title }}</span>
							</th>
						</tr>
					</thead>
				</table>
			</div>
		</div>
		<div class="ms-header-nocontent" v-else>
			<div class=""></div>
		</div>
		<div
			v-if="!isFirstFilter"
			class="text-center h-full flex-box justify-center"
		>
			<div class="icon-area">
				<div class="mi-new-v2 mi-175 mi-no-data-report mb-4"></div>
			</div>
			<div class="text-nondata-area">
				{{ $t('i18nReport.SelectDateRangeReport') }}
			</div>
		</div>
		<div
			class="ms-content--table"
			@scroll="onScroll"
			:style="[gridViewStyle]"
			ref="content"
			v-else-if="!dataEmpty || shimmerLoaded === false"
			:class="classContentTable"
		>
			<table class="ms-table" v-if="groupField">
				<tbody class="ms-tbody">
					<ms-group-tr
						v-for="(dataRow, indexRow) in datax"
						:isSelected="isSelected(dataRow)"
						:key="dataRow['__vKeyValue']"
						:columns="columnx"
						:index="indexRow"
						:dataRow="dataRow"
						:widgetOptions="widgetOptions"
						:widgetOptionsLeft="widgetOptionsLeft"
						:serial="serial"
						:pageSize="pageSize"
						:currentPage="currentPage"
						:multiple="multiple"
						:multipleDisabled="multipleDisabled"
						v-on="listeners"
						:groupField="groupField"
						:loadChildrenData="loadChildrenData"
						:isGridReport="isGridReport"
					></ms-group-tr>
				</tbody>
			</table>
			<table class="ms-table" v-else>
				<transition
					name="trans-content-table"
					mode="out-in"
					v-on:before-enter="beforeRenderContent"
				>
					<tbody
						class="ms-tbody"
						v-if="shimmerLoaded !== false"
						:key="shimmerLoaded"
					>
						<template>
							<ms-tr
								ref="tr"
								v-for="(dataRow, indexRow) in datax"
								:isSelected="isSelected(dataRow)"
								:key="dataRow['__vKeyValue']"
								:columns="columnx"
								:index="indexRow"
								:dataRow="dataRow"
								:widgetOptions="widgetOptions"
								:widgetOptionsLeft="widgetOptionsLeft"
								:widgetColumn="widgetColumn"
								:serial="serial"
								:pageSize="pageSize"
								:currentPage="currentPage"
								:multiple="multiple"
								:multipleDisabled="multipleDisabled"
								:isScrollLeft="isScrollLeft"
								v-on="listeners"
								:class="[
									{ 'ms-tr-last': datax && indexRow == datax.length - 1 },
									{ 'row-selected': dataRow == rowSelected.data },
									{ 'action-pointer': checkListenerDbClick },
									typeof customClassRow == 'function'
										? customClassRow(dataRow)
										: customClassRow,
								]"
								:isTree="isTree"
								:isBorderTr="isBorderTr"
								:isBorderTh="isBorderTh"
								:isActionView="isActionView"
								:isGridReport="isGridReport"
								:truncateOverflow="truncateOverflow"
								:rowActionsWidget="rowActionsWidget"
								:rowActionsWidgetProps="rowActionsWidgetProps"
							></ms-tr>
						</template>
					</tbody>
					<tbody
						class="ms-tbody"
						v-if="shimmerLoaded === false"
						:key="shimmerLoaded"
					>
						<template>
							<ms-tr
								ref="tr"
								v-for="n in 5"
								:key="n"
								:index="n"
								:columns="columnx"
								:widgetOptions="widgetOptions"
								:widgetOptionsLeft="widgetOptionsLeft"
								:serial="serial"
								:multiple="multiple"
								isChart
								:isBorderTr="isBorderTr"
								:isBorderTh="isBorderTh"
								:isActionView="isActionView"
								:isGridReport="isGridReport"
								:truncateOverflow="truncateOverflow"
								:rowActionsWidget="rowActionsWidget"
								:rowActionsWidgetProps="rowActionsWidgetProps"
							></ms-tr>
						</template>
					</tbody>
				</transition>
			</table>
		</div>
		<div
			v-else-if="hasFilterEmpty"
			class="text-center h-full flex-box justify-center"
		>
			<img :src="require(`@/assets/images/pages/No_data.svg`)" />
			<div class="mt-4">{{ $t('i18nCommon.NoFilterData') }}</div>
		</div>
		<div v-else class="text-center h-full flex-box justify-center">
			<ms-no-data
				:noDataSlot="noDataSlot"
				:options="getFilterEmptyOptions"
				:isScreenMall="isScreenMall"
			>
				<template #noData>
					<slot name="noData"></slot>
				</template>
			</ms-no-data>
		</div>

		<ms-pagination
			ref="pagination"
			v-if="pagination"
			:pageSize="pageSize"
			:dataRender="isPagingV2 ? dataxIndex.length : datax.length"
			:pageIndexCurrent="currentPage"
			:pageTotal="pageTotal"
			:pageButtomValue="pageButtomValue"
			@loadData="listenersLoadData"
			:customProp="customProp"
			@clickPage="clickPage"
			:isLoadingTotalRecord="isLoadingTotalRecord"
			:listType="listType"
		></ms-pagination>
	</div>
</template>
<script>
import msTr from './msTrGroup';
import msGroupTr from './msGroupTr';
import msTh from './msTh';
import msThGroup from './msThGroup';
import msPagination from './msPaginationViewer';
import commonFunc from '@/common/commonFunction.js';
import msDynamicScroll from '@/components/msvirtualscroller/MsDynamicScroller.vue';
import msDynamicScrollerItem from '@/components/msvirtualscroller/MsDynamicScrollerItem.vue';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { isNullOrEmpty } from '@/common/objectUtil';
import '@/common/arrayUtil';
export default {
	name: 'msGridViewerV2',
	components: {
		msTr,
		msGroupTr,
		msTh,
		msThGroup,
		msPagination,
		msDynamicScroll,
		msDynamicScrollerItem,
	},
	props: {
		isGridReport: {
			default: false,
			type: Boolean,
		},
		isPagingV2: {
			default: false,
			type: Boolean,
		},
		greyTitle: {
			default: false,
			type: Boolean,
		},
		//Value thực hiện lưu giá trị các cột được chọn
		value: {},
		//Data dữ liệu grid từ ngoài truyền vào
		data: {
			type: Array,
			return: () => [],
		},
		//Cấu hình các cột truyền vào
		/**
		 * Các thuộc tính trong columns
		 * @params dataField Field dữ liệu dùng để nhận giá trị thay đổi và hiện thị. Ngăn cách dấu '.' để truy cập sâu vào các đối tượng con
		 * @params title:Tiêu đề của cột
		 * @params width:độ rộng của cột
		 * @params autoResize:Cột tự động to ra khi màn hình lớn
		 * @params formatType:Dữ liệu dùng để format lấy từ trong file enumeration.js FormatType
		 * @params template:Sử dụng 1 file khác ở ngoài truyền vào để render
		 */
		columns: {
			type: Array,
			return: () => [],
		},
		/**
		 * Cấu hình cho cột chức năng là 1 đối tượng gồm có
		 * title: tên tiêu đề cột chức năng
		 * components:'components import vào'
		 * width:Độ rộng của cột
		 */
		widgetOptions: {},
		// Cấu hình cột chức năng thêm bên trái danh sách
		widgetOptionsLeft: {},
		// Cột được thiết lập trong danh sách thiết lập là icon
		widgetColumn: {},
		//Set độ rộng cho grid
		maxHeight: {
			default: null,
			type: [Number, String],
		},
		//Cấu hình có phân trang hay không
		pagination: {
			default: false,
			type: Boolean,
		},
		//Nhận 2 giá trị remote/local để lấy giá trị ở server hoặc local
		queryMode: {
			default: 'remote',
			type: String,
		},
		//Cột cho phép tích chọn nhiều dòng
		multiple: {
			default: false,
			type: Boolean,
		},
		indexFlexRight: {
			default: 1,
			type: Number,
		},
		//Tổng số bản ghi
		pageTotal: {
			default: 0,
			type: Number,
		},
		//Hiện thị cột số thứ tự
		serial: {
			default: false,
			type: Boolean,
		},
		//Cho phép di chuyển độ rộng của cột hay không
		resizeCol: {
			default: true,
			type: Boolean,
		},
		//Trường để kiểm tra sort dưới client hay trên sever
		remoteSort: {
			default: false,
			type: Boolean,
		},
		//Data là dạng Master/Detail
		isMasterDetail: {
			default: false,
			type: Boolean,
		},
		detailField: {
			default: 'Details',
			type: String,
		},
		hasFilterEmpty: {
			default: false,
			type: Boolean,
		},
		shimmerLoaded: {
			default: null,
		},
		customClassRow: {
			default: null,
		},
		groupField: {
			default: null,
			type: String,
		},
		loadChildrenData: {
			default: null,
		},
		multipleDisabled: {
			default: false,
			type: Boolean,
		},
		pageButtomValue: {
			type: Array,
			return: () => [],
		},
		//Cho phép sắp xếp cột trên grid hay không
		sortCol: {
			default: false,
			type: Boolean,
		},
		name: {
			default: '',
			type: String,
		},
		isTree: {
			default: false,
			type: Boolean,
		},
		sortCondition: {},
		isCustomAlignDate: {
			default: false,
			type: Boolean,
		},
		nameGrid: {
			default: null,
			type: String,
		},
		/**
		 * Có loading tổng số bản ghi hay không
		 */
		isLoadingTotalRecord: {
			default: false,
			type: Boolean,
		},
		customGridLayout: {},
		isSelectManyPage: {
			default: false,
			type: Boolean,
		},
		/**
		 * Key khóa chính của dữ liệu
		 */
		keyFieldData: {
			default: null,
			type: String,
		},
		/**
		 * Giá trị của lựa chọn tất cả
		 */
		valueAll: {},
		isBorderTr: {
			default: true,
			typeof: Boolean,
		},
		isBorderTh: {
			default: true,
			typeof: Boolean,
		},
		isFirstFilter: {
			default: true,
			typeof: Boolean,
		},
		isActionView: {
			default: false,
			typeof: Boolean,
		},
		/**
		 * Dữ liệu lọc trên grid
		 */
		filterGrids: {
			type: Array,
			return: () => [],
		},
		listType: 0,
		tooltipCheckboxMulti: {
			type: String,
			default: '',
		},
		noDataSlot: {
			type: Boolean,
			default: false,
		},
		filterEmptyOptions: {},
		classContentTable: {
			default: '',
			typeof: String,
		},
		classContentHeader: {
			default: '',
			typeof: String,
		},
		customProp: {},
		/**
		 * Có hiển thị tiêu đề cột khi không có dữ liệu hay không ?
		 */
		isShowContentHeader: {
			default: false,
			typeof: Boolean,
		},
		/**
		 * Bật truncate text trong cell: text dài quá width cột thì ẩn bớt (ellipsis),
		 * hover xem đầy đủ qua tooltip. Mặc định false giữ behavior cũ (giãn cột theo nội dung).
		 */
		truncateOverflow: {
			default: true,
			type: Boolean,
		},
		/**
		 * Cấu hình chung cho grid: rowActionsWidget (component action nổi lên khi hover vào dòng,
		 * thay thế cột widget chiếm chỗ), rowActionsWidgetProps (props tùy biến forward xuống widget).
		 */
		gridOptions: {},
	},
	/**
	 * Hàm khởi tạo grid khởi tạo column vào data
	 * Created by LTDAT 16.06.2020
	 */
	created() {
		const me = this;
		me.initColumns();
		me.initData();
		me.initFilterGrids();
		document.addEventListener('click', me.clickOutGrid);
		window.addEventListener('resize', me.onResize);
		EventBusGlobal.$on(GlobalEventName.ResizeMsThGroup, me.updateScroll);
	},
	/**
	 *
	 */
	watch: {
		data: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.checkHasScroll();
				if (me.datax != me.data) {
					me.initData(newVal);
					if (me.sortCondition && me.sortCondition.col) {
						me.sort(me.sortCondition.col, me.sortCondition.sortStatus);
					}
				}
			},
		},

		scrollVisiable: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				if (me.customProp && me.customProp.setStyleScroll) {
					me.setStyleWidget();
				}
			},
		},

		filterGrids: {
			handler(newVal, oldVal) {
				const me = this;
				if (!_.isEqual(me.filterHeaders, me.filterGrids)) {
					me.initFilterGrids(newVal);
				}
			},
		},

		pageTotal: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.currentPage = 1;
			},
		},

		columns: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				me.initColumns();
			},
		},
		isScreenMall: {
			handler(newVal, oldVal) {
				const me = this;
				me.isScreenMall = me.$ms.commonFunc.checkSmallScreen();
			},
		},
	},
	mounted() {
		const me = this;
	},
	beforeDestroy() {},
	computed: {
		getFilterEmptyOptions() {
			const me = this;
			if (!me.filterEmptyOptions) return {};
			return me.filterEmptyOptions;
		},
		//Kiểm tra có lắng nghe xử lý sự kiện dblick hay không? nếu có thì đổi icon thành pointer
		checkListenerDbClick() {
			if (this._events.dblclick && this._events.dblclick.length > 0) {
				return true;
			}
			return false;
		},

		/**
		 * Truyền qua gridOptions.rowActionsWidget khi danh sách muốn tự xử lý action trong 1 component riêng
		 * (vd: ReportInvoiceRelatedWidget) thay vì cột widget chiếm chỗ — hover vào dòng hiện overlay.
		 */
		rowActionsWidget() {
			return (this.gridOptions && this.gridOptions.rowActionsWidget) || null;
		},
		/**
		 * Props tùy biến forward xuống rowActionsWidget qua msTr, đọc từ gridOptions.rowActionsWidgetProps.
		 */
		rowActionsWidgetProps() {
			return (this.gridOptions && this.gridOptions.rowActionsWidgetProps) || {};
		},

		/**
		 * Thực hiện ẩn hiện columns theo visiable
		 */
		visibleColumns() {
			const filterVisibleColumns = (
				columns = [],
				isChild = false,
				lastIndex = -1
			) => {
				let lastVisibleColumnIndex = -1;

				const filteredColumns = columns.filter((column, index) => {
					if (!column.visiable || column.visiable === false) {
						return false;
					}
					if (column.children && column.children.length > 0) {
						column.children = filterVisibleColumns(column.children, true);
					}
					lastVisibleColumnIndex = index;
					return true;
				});

				//Thực hiện set trường lastCol để bỏ border cho các columns nhiều cấp trong msthgroup
				if (
					filteredColumns[lastVisibleColumnIndex] &&
					lastIndex == lastVisibleColumnIndex
				) {
					if (isChild) {
						filteredColumns[lastVisibleColumnIndex].lastColChildren = true;
					} else {
						filteredColumns[lastVisibleColumnIndex].lastColParent = true;
					}

					if (
						filteredColumns[lastVisibleColumnIndex].children &&
						filteredColumns[lastVisibleColumnIndex].children.length > 0
					) {
						markChildren(filteredColumns[lastVisibleColumnIndex].children);
					}
				}

				return filteredColumns;
			};

			const markChildren = (children) => {
				let lastVisibleChildIndex = -1;

				children.forEach((child, index) => {
					if (child.visiable !== false) {
						lastVisibleChildIndex = index;
					}
				});

				if (lastVisibleChildIndex !== -1) {
					children[lastVisibleChildIndex].lastColChildren = true;

					if (
						children[lastVisibleChildIndex].children &&
						children[lastVisibleChildIndex].children.length > 0
					) {
						markChildren(children[lastVisibleChildIndex].children);
					}
				}
			};
			//PDDang test trên môi micro edge không chạy được do phiên bản không hỗ trợ func findLastIndex => thực hiện sửa thêm trong arrayUtils.js
			let lastIndex = this.columns.findLastIndex((column) => column.visiable);
			return filterVisibleColumns(this.columns, false, lastIndex);
		},

		//Hàm kiểm tra xem có scroll hay không?
		scrollVisiable() {
			if (this.hasScroll) {
				return true;
			}
			return false;
		},
		//Sự kiện từ 1 dòng dữ liệu emit ra ngoài
		//Created by LTDAT(18.06.2020)
		listeners() {
			const me = this;
			return {
				click: (dataRow, event) => {
					event.target.focus();
					me.$emit('click', dataRow, event);
				},
				focus: (dataRow, event) => {
					if (me.rowSelected && me.rowSelected.data != dataRow) {
						let indexRow = me.datax.findIndex((item) => item == dataRow);
						me.rowSelected = {
							data: dataRow,
							index: indexRow,
						};
						event.target.focus();
					}
				},
				dblclick: (dataRow, event) => {
					me.$emit('dblclick', dataRow, event);
				},
				keydown: (dataRow, event) => {
					me.row_keydown(dataRow, event);
					me.$emit('keydown', dataRow, event);
				},
				widgetEvent: (data, event) => {
					me.$emit('widgetEvent', data, event);
				},
				clickMultiple: (dataRow) => {
					me.clickMultiple(dataRow);
				},
			};
		},
		/**
		 * Kiểm tra xem tất cả dữ liệu có đang được check hay không
		 * created by LTDAT 25.06.2020
		 */
		isCheckedMultiple() {
			const me = this;
			if (me.value && me.datax && me.datax.length != 0) {
				if (me.datax.length != 0) {
					return (
						me.value.length >= this.datax.length &&
						me.datax.every((item, index) => {
							if (me.keyFieldData) {
								let exist = me.value.find(
									(x) => x[`${me.keyFieldData}`] == item[`${me.keyFieldData}`]
								);
								if (exist) return true;
							}
							return me.value.includes(item);
						})
					);
				}
			}
			return false;
		},
		// //Set style cho grid độ rộng,...
		gridViewStyle() {
			if (this.maxHeight) {
				return { 'max-height': this.maxHeight };
			} else {
				return null;
			}
		},
		dataEmpty() {
			if (this.datax && this.datax.length > 0) {
				return false;
			} else return true;
		},

		dataxIndex() {
			if (!this.datax || this.datax.length <= 0) {
				return [];
			}
			return this.datax.filter(
				(item, index, self) =>
					index ===
					self.findIndex(
						(i) => i[this.keyFieldData] === item[this.keyFieldData]
					)
			);
		},
	},
	//Nếu dữ liệu thay đổi thì check scroll
	updated() {
		const me = this;
		me.updateSize();
	},
	methods: {
		/**
		 * Khi màn hình thay đổi thì update lại các cột.
		 * Created by LTDAT(19/01/2020)
		 */
		onResize() {
			const me = this;
			me.initColumns();
			me.updateSize();
		},
		updateScroll() {
			const me = this;
			me.setStyleWidget();
		},
		/**
		 * Hàm Cập nhật lại giao diện khi có scroll hay khi độ rộng của data dài hơn độ rộng mặc định của cột
		 * Created by LTDAT
		 */
		updateSize() {
			const me = this;
			me.$nextTick(() => {
				me.checkHasScroll();
				// Khi bật truncateOverflow thì cố định width cột theo cấu hình, không tự giãn theo nội dung
				if (me.truncateOverflow) return;
				if (me.$refs.tr && me.$refs.tr.length > 0) {
					me.columnx.forEach((col, index) => {
						let changeMinWidth = false;
						// Duyệt các dòng
						me.$refs.tr.forEach((item) => {
							if (
								item.$refs[`text-${col.dataField}`] &&
								item.$refs[`text-${col.dataField}`].length > 0
							) {
								let textSpan =
									item.$refs[`text-${col.dataField}`][0].offsetWidth;
								if (col._width < textSpan + 20) {
									changeMinWidth = true;
									if (
										me.$refs.th[index].$el.offsetWidth !=
										item.$refs[`td-${col.dataField}`][0].offsetWidth
									) {
										me.$set(
											col,
											'_minWidth',
											item.$refs[`td-${col.dataField}`][0].offsetWidth
										);
										me.$set(
											col,
											'_width',
											item.$refs[`td-${col.dataField}`][0].offsetWidth
										);
									}
								}
							}
						});
						if (changeMinWidth == false) {
							me.$set(col, '_minWidth', col._width);
						}
					});
				}
			});
		},
		/**
		 * Hàm trước thực hiện transition bắt đầu render.
		 * Created by LTDAT
		 */
		beforeRenderContent() {
			const me = this;
			me.updateSize();
		},
		/**
		 * Thực hiện khi ấn vào ngoài grid loại bỏ row đang chọn
		 * Created by LTDAT
		 *
		 * */
		clickOutGrid(event) {
			const me = this;
			if (event.target.closest('.ms-grid-viewer') != me.$el) {
				me.rowSelected = {};
			}
		},
		/**
		 * Hàm thực hiện việc sort trên grid
		 * @params col cột được thực hiện sắp sếp
		 * @params mode gồm null,DESC,ASC
		 * created by LTDAT
		 */
		sort(col, mode) {
			const me = this;
			// Cột không được sort dữ liệu
			if (!col || !col.isSort) return;

			if (me.datax && me.datax.length > 0) {
				//Comment lại tạm thời không sort dữ liệu danh sách từ server
				if (me.remoteSort) {
					// let payload = {
					// 	skip: (me.currentPage - 1) * me.pageSize,
					// 	take: me.pageSize
					// };
					// if (mode != me.$ms.enum.SortStatus.none) {
					// 	payload.Sort = `${col.dataField} ${
					// 		mode == me.$ms.enum.SortStatus.desc ? 'DESC' : 'ASC'
					// 	}`;
					// }
					// me.listenersLoadData(payload);
				} else {
					let data = [...me.internalDataSource];

					function compare(a, b) {
						if (!a[col.dataField] && b[col.dataField]) {
							return mode == me.$ms.enum.SortStatus.desc ? 1 : -1;
						}
						if (a[col.dataField] && !b[col.dataField]) {
							return mode == me.$ms.enum.SortStatus.asc ? 1 : -1;
						}
						if (a[col.dataField] < b[col.dataField])
							return mode == me.$ms.enum.SortStatus.desc ? 1 : -1;
						if (a[col.dataField] > b[col.dataField])
							return mode == me.$ms.enum.SortStatus.asc ? 1 : -1;
						if (a[col.dataField] == b[col.dataField]) {
							if (a['CreatedDate'] > b['CreatedDate']) {
								return mode == me.$ms.enum.SortStatus.asc ? 1 : -1;
							}
							if (a['CreatedDate'] < b['CreatedDate']) {
								return mode == me.$ms.enum.SortStatus.desc ? 1 : -1;
							}
						}
						return 0;
					}
					if (mode != me.$ms.enum.SortStatus.none) {
						me.datax = data.sort(compare);
					} else {
						me.datax = data;
					}

					this.$emit('loadDataSort', me.datax);
				}
				me.sortCondition.col = col;
				me.sortCondition.sortStatus = mode;
			}
		},
		//Kiểm tra xem grid có scroll hay không để chỉnh lại size của grid cho đúng
		//Created by LTDAT (29.07.2020)
		checkHasScroll() {
			this.$nextTick(() => {
				if (this.$refs.content) {
					if (
						this.$refs.content.getBoundingClientRect().height + 2 <
						this.$refs.content.scrollHeight
					) {
						this.hasScroll = true;
					} else {
						this.hasScroll = false;
					}
					if (this.customProp && this.customProp.setStyleScroll) {
						this.setStyleWidget();
					}
				}
			});
		},
		/**
		 * Hàm lắng nghe sự kiến thay đổi trang nếu thay đổi thì emit sự kiện load data mới ra ngoài
		 * @param payload dữ liệu thông tin trang gửi ra ngoài
		 *  */
		//Created by LTDAT(27.07.2020)
		listenersLoadData(payload, loadFirstIndex = false) {
			const me = this;
			if (me.pagination) {
				me.currentPage = payload.skip / payload.take + 1;
				me.pageSize = payload.take;
			}

			if (me.$refs.th && me.sortCol) {
				let params = me.getParamSort();
				if (params) {
					let dataField = params && params.col ? params.col.dataField : '';
					payload.Sort = `${dataField} ${
						params.sortStatus == me.$ms.enum.SortStatus.desc ? 'DESC' : 'ASC'
					}`;
				}
			}

			if (loadFirstIndex && me.currentPage != 1) {
				me.currentPage = 1;
			}
			me.$emit('loadData', payload);
		},

		/**
		 * Lấy thông tin tham số trường và trạng thái sort
		 */
		getParamSort() {
			const me = this;
			if (!me.$refs.th && !me.sortCol) return null;
			let th = me.$refs.th.find(
				(x) => x.sortStatus != me.$ms.enum.SortStatus.none
			);
			if (!th) return null;
			return {
				col: th.col,
				sortStatus: th.sortStatus,
			};
		},
		//Hàm sự kiện khi ấn nút chọn tất cả trên tiêu đề
		//Created by LTDAT
		changeCheckedMultiple() {
			const me = this;
			me.setDataSelectInGrid();
		},

		setDataSelectInGrid() {
			const me = this;
			//Lựa chọn select dữ liệu trên nhiều page
			if (me.isSelectManyPage) {
				if (me.isCheckedMultiple) {
					me.setDataSelectPage(me.datax, true);
					me.$emit('input', me.dataAll);
				} else {
					me.setDataSelectPage(me.datax, false);
					me.$emit('input', me.dataAll);
				}
			} else {
				if (me.isCheckedMultiple) {
					me.$emit('input', []);
				} else {
					me.$emit('input', me.datax);
				}
			}
		},

		setDataSelectPage(datax, isDelete = false) {
			const me = this;
			if (!datax || datax.length <= 0) return;
			if (!me.dataAll || me.dataAll.length <= 0) me.dataAll = [];
			if (isDelete) {
				if (me.keyFieldData) {
					me.dataAll = me.dataAll.filter(
						(x) =>
							!datax.find(
								(a) => a[`${me.keyFieldData}`] == x[`${me.keyFieldData}`]
							)
					);
				} else {
					me.dataAll = me.dataAll.filter((x) => !datax.includes(x));
				}
			} else {
				me.dataAll = [...me.dataAll, ...datax];
				//Distinct  data array
				if (me.keyFieldData) {
					me.dataAll = me.$ms.commonFunc.distinctArray(
						me.dataAll,
						me.keyFieldData
					);
				}
			}
		},

		setStyleWidget() {
			const me = this;
			me.$nextTick(() => {
				// me.setShowWidget();
				me.setBackgroundColorWidget();
			});
		},

		isDefaultColor(color) {
			// Kiểm tra định dạng RGB hoặc RGBA
			const rgbMatch = color.match(
				/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d*\.?\d*))?\)/
			);
			if (rgbMatch) {
				const r = parseInt(rgbMatch[1]);
				const g = parseInt(rgbMatch[2]);
				const b = parseInt(rgbMatch[3]);
				const alpha = rgbMatch[4] ? parseFloat(rgbMatch[4]) : 1;

				return r === 0 && g === 0 && b === 0 && (alpha === 0 || alpha === 1);
			}

			// Kiểm tra định dạng HEX
			const hexMatch = color.match(/^#?([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/);
			if (hexMatch) {
				const hex =
					hexMatch[1].length === 3
						? hexMatch[1]
								.split('')
								.map((x) => x + x)
								.join('')
						: hexMatch[1];
				const r = parseInt(hex.substr(0, 2), 16);
				const g = parseInt(hex.substr(2, 2), 16);
				const b = parseInt(hex.substr(4, 2), 16);

				// Kiểm tra nếu là màu đen
				return r === 0 && g === 0 && b === 0; // Đen
			}

			// Nếu không khớp với cả hai định dạng, trả về false
			return false;
		},

		/**
		 * Thực hiện set color cho widget khi khởi tạo hay scroll hay khi load lại trang
		 * pddang 25/09/2024
		 */
		setBackgroundColorWidget() {
			const me = this;
			me.$nextTick(() => {
				let contentGrid = me.$refs.content; //content gridviewv2
				let header = me.$refs.header; //header gridviewv2
				let widget = me.$refs.headerRightWeight; //widget gridviewv2
				let msSideBar = document.getElementsByClassName('content-sidebar')[0]; //sidebar
				let contentView = document.getElementsByClassName('content-view')[0]; //content view
				if (!header || !widget) {
					return;
				}
				//Trường hợp không có contentGrid => Không có bản ghi nào
				if (!contentGrid) {
					// widget.style.display = 'none';
					return;
				}

				const defWidth = {
					none: 0,
					widget: 100, //Độ rộng widget
					msSideBar: 240, //Độ rộng sidebar
					contentViewPadding: 16, //Padding content view
					positionBeforeWidget: 2, //Tọa độ trước widget 2px để lấy mã màu
					widgetHeight: 25, //Độ cao widget trong trường hợp lớn hơn độ cao min thì chỉ lấy ở 25px cộng thêm
					hiddenScroll: 16, //Độ rộng của thanh hidden-scroll
				};
				let hasClassHideScroll = header.classList.contains('hide-scroll');
				if (hasClassHideScroll) {
					header.classList.remove('hide-scroll');
					widget.style.minWidth =
						(me.widgetOptions.width
							? me.widgetOptions.width
							: widget.getBoundingClientRect().width) +
						defWidth.hiddenScroll +
						'px';
				}

				let posX =
					contentGrid.clientWidth -
					(widget
						? me.widgetOptions.width
							? me.widgetOptions.width
							: widget.getBoundingClientRect().width
						: defWidth.widget) +
					(msSideBar
						? msSideBar.getBoundingClientRect().width
						: defWidth.msSideBar) +
					(contentView
						? parseFloat(window.getComputedStyle(contentView).padding)
							? parseFloat(window.getComputedStyle(contentView).padding)
							: defWidth.contentViewPadding
						: defWidth.contentViewPadding) +
					(hasClassHideScroll ? defWidth.hiddenScroll : defWidth.none) -
					defWidth.positionBeforeWidget;
				let posY = widget.getBoundingClientRect().top + defWidth.widgetHeight;
				//Lấy element tại vị trí trước widget
				let element = document.elementFromPoint(posX, posY);

				//Trường hợp không lấy được element
				if (!element) return;

				//Trường hợp element đó là loading do load api chưa xong thì thực hiện call thêm lần nữa (trường hợp f5)
				if (element.id == 'loading-bg') {
					setTimeout(() => {
						me.setBackgroundColorWidget();
						return;
					}, 100);
				}

				//Trường hợp không lấy được mã màu
				let backgroundColor = window.getComputedStyle(element).backgroundColor;
				if (
					!backgroundColor ||
					me.isDefaultColor(backgroundColor) ||
					(me.customProp && me.customProp.setStyleScroll)
				) {
					//Trường hợp title truyền vào
					if (Object.keys(me.customGridLayout).length > 0) {
						me.columns.forEach((col) => {
							if (
								me.$t(
									`${me.customGridLayout.i18n}.${me.customGridLayout.layoutID}`
								)[`${col.title}`] == element.innerText
							) {
								me.setBackgroundColor(widget, col);
								return;
							}
						});
					} else {
						me.columns.forEach((col) => {
							if (col.title == element.innerText) {
								me.setBackgroundColor(widget, col);
								return;
							}
						});
					}
					return;
				}
				widget.style.backgroundColor = backgroundColor;
			});
		},

		setBackgroundColor(widget, col) {
			const me = this;
			const defaultColor = '#f3f4f7';

			widget.style.backgroundColor = col.backgroundColor
				? col.backgroundColor
				: defaultColor;
		},

		setShowWidget(isFirst = false) {
			const me = this;
			let content = me.$refs.content;
			let header = me.$refs.header;
			let widget = me.$refs.headerRightWeight;
			let msSideBar = document.getElementsByClassName('content-sidebar')[0];
			//Độ dài thanh cuộn
			let scrollWidth = content.scrollWidth - content.clientWidth;

			widget.style.height = header.getBoundingClientRect().height + 'px';
			//Trường hợp chưa scroll hoặc scroll nhỏ hơn chiều dài của content
			if (
				content.scrollLeft >=
				content.scrollWidth - content.clientWidth - content.clientWidth
			) {
				if (isFirst) {
					widget.style.display = 'none';
					// me.showWidgetOptionTr();
				} else {
					widget.style.display = 'block';
					// me.showWidgetOptionTr(true);
				}
			} else {
				widget.style.display = 'none';
				// me.showWidgetOptionTr();
			}
		},

		showWidgetOptionTr(isShow = false) {
			const me = this;
			if (!me.$refs.tr || me.$refs.tr.length <= 0) return;

			me.$refs.tr.forEach((item, index) => {
				item.$refs[`widget-${index}`].$el.style.display = isShow
					? 'block'
					: 'none';
			});
		},

		/**
		 * Sự kiện scroll trên grid
		 * Thay đổi lại tọa độ scroll trên header
		 * Created by LTDAT(25.06.2020)
		 */
		onScroll(e) {
			const me = this;
			if (me.$refs.header) {
				me.$refs.header.scrollLeft = e.target.scrollLeft;
			}
			if (e.target.scrollLeft != 0) {
				me.isScrollLeft = true;
			} else {
				me.isScrollLeft = false;
			}
			let gridCoordinates = me.$refs.content.scrollLeft;

			if (me.customProp && me.customProp.setStyleScroll) {
				//Xử lý set style cho widget
				me.setStyleWidget();
			}

			EventBusGlobal.$emit(GlobalEventName.scrollEvent, e);
			me.$emit('scroll', e, gridCoordinates);
		},

		/**
		 * Hàm scroll tới vị trí chỉ định
		 * @param {*} gridCoordinates
		 * @author hvanh - 19.1.2024
		 */
		onScrollToCoordinates(gridCoordinates) {
			const me = this;
			if (!me.$refs.content || (!gridCoordinates && gridCoordinates !== 0))
				return;

			if (typeof gridCoordinates == 'number' && gridCoordinates >= 0) {
				me.$refs.content.scrollLeft = gridCoordinates;
			}
		},

		/**
		 * Kiểm tra xem cột được check hay không ?
		 * duyệt trong data nếu có chưa dữ liệu của dòng tương ứng thì return true ngược lại false
		 * @param dataRow dữ liệu của dòng được check
		 * Created by LTDAT 24.06.2020
		 *  */
		isSelected(dataRow) {
			const me = this;
			if (me.value && me.value.length > 0) {
				if (me.keyFieldData) {
					let exist = me.value.find(
						(x) => x[`${me.keyFieldData}`] == dataRow[`${me.keyFieldData}`]
					);
					if (exist) return true;
				}
				return me.value.includes(dataRow);
			}
			return false;
		},
		/**
		 * Hàm xử lý sự kiện khi click vào ô check multiple
		 * @param dataRow dữ liệu của dòng được chọn
		 * Created by LTDAT (30.05.2020)
		 */
		clickMultiple(dataRow) {
			const me = this;
			let VModel = [...me.value];

			if (me.keyFieldData) {
				let checkExist = me.dataAll.find(
					(x) => x[`${me.keyFieldData}`] == dataRow[`${me.keyFieldData}`]
				);
				if (checkExist) {
					me.dataAll = me.dataAll.filter(
						(x) => x[`${me.keyFieldData}`] != dataRow[`${me.keyFieldData}`]
					);
				} else {
					me.dataAll.push(dataRow);
				}
				VModel = me.dataAll;
			} else {
				if (VModel.includes(dataRow)) {
					VModel.remove(dataRow);
				} else {
					VModel.push(dataRow);
				}
			}
			// Lấy danh sách được chọn: sắp xếp giống như trên phần mềm
			if (me.datax) {
				for (let i = 0; i < VModel.length - 1; i++) {
					for (let j = i + 1; j < VModel.length; j++) {
						let index = me.datax.findIndex(
							(data) => data.InvoiceId == VModel[i].InvoiceId
						);
						let index1 = me.datax.findIndex(
							(data) => data.InvoiceId == VModel[j].InvoiceId
						);
						let tem = {};
						if (index > index1) {
							tem = VModel[i];
							VModel[i] = VModel[j];
							VModel[j] = tem;
						}
					}
				}
			}
			me.$emit('input', VModel);
		},

		//Lấy dữ liệu của 1 trang khi phân trang local
		//Created by LTDAT(18.06.2020)
		getItemPagination() {
			let me = this,
				pageSize = me.pageSize
					? me.pageSize
					: me.$ms.commonFunc.getTakePageSize(),
				min = Math.ceil((me.currentPage - 1) * pageSize),
				max = min + pageSize;
			let dataPagination = me.internalDataSource.filter((item, index) => {
				return index >= min && index < max;
			});
			return dataPagination;
		},
		//Xử lý sự kiện resize col trên grid
		//created by LTDAT(29.05.2020)
		resizeActive(data) {
			//Không cho phép bôi đen text
			this.isResizeActive = true;
			if (this.$refs.th) {
				let listTh = this.$refs.th;
				if (listTh && listTh.length > 0) {
					listTh.forEach((item) => {
						if (item == listTh[listTh.length - this.indexFlexRight]) {
							item.updateColWidth(true);
						} else {
							item.updateColWidth(false);
						}
					});
				}
			}
		},
		//Đóng sự kiện resize cột trên grid
		//created by LTDAT(29.05.2020)

		resizeClose() {
			//Cho phép bôi đên text
			this.isResizeActive = false;
		},
		/**
		 * Set giá trị default cho cấu hình cột
		 * Created by LTDAT(17.07.2020)
		 */
		setDefaultFieldColumn(columns) {
			//Nếu không cấu hình field hiện thị thì mặc định là true
			const me = this;
			columns.forEach((item) => {
				if (item.visiable != false) {
					item.visiable = true;
				}
				if (item.formatType == me.$ms.enum.FormatType.Number && !item.align) {
					item.align = 'right';
				} else if (
					item.formatType == me.$ms.enum.FormatType.Date ||
					item.formatType == me.$ms.enum.FormatType.DateTime
				) {
					if (me.isCustomAlignDate) {
						item.align = 'left';
					} else {
						item.align = 'center';
					}
				}
				me.$set(item, '_width', item.width);
				//default filter
				if (!item.filter) {
					me.setDefaultFilter(item);
				}
			});
		},
		/** Lấy ra các column có thuộc tính visiable = true
		 * Created by LTDAT 17.07.2020
		 * */
		getVisiableColumn(columns) {
			return columns.filter((item) => {
				return item.visiable == true;
			});
		},

		/**
		 * Đệ quy gom các cột lá (không còn children) vào mảng kết quả.
		 * Dùng result truyền xuống thay vì push thẳng me.columnx để initColumns
		 * luôn assign lại mảng mới — tránh cột body nhân đôi khi nhiều lần
		 * initColumns/initData lồng nhau trong cùng một tick (đổi chi nhánh + lọc).
		 */
		setColumnx(columns = [], result = []) {
			const me = this;

			//Không có thông tin cột
			if (!columns || columns.length <= 0) return result;

			//Duyệt các cột để xử lý
			columns.forEach((item) => {
				if (!item.children || item.children.length <= 0) {
					if (item.visiable) result.push(item);
				} else {
					me.setColumnx(item.children, result);
				}
			});
			return result;
		},

		/**
		 * Khởi tạo dữ liệu ban đầu cho grid
		 * columns truyền vào mặc định là columns trong props có thể truyền cấu hình khác từ ngoài vào
		 */
		initColumns(columns = this.columns) {
			const me = this;
			me.$nextTick(() => {
				let columnx = columns ? columns : me.columns;
				me.columnx = me.setColumnx(columnx);
				me.columnx = me.getVisiableColumn(me.columnx);
				me.setDefaultFieldColumn(me.columnx);
				if (!me.columnx) {
					me.columnx = [];
				}
				let hasFlex = me.columnx.some((item) => {
					return item.autoResize;
				});
				if (
					hasFlex == false &&
					me.columnx[me.columnx.length - me.indexFlexRight]
				) {
					// me.resizeActive();
					me.$set(
						me.columnx[me.columnx.length - me.indexFlexRight],
						'autoResize',
						true
					);
				} else if (hasFlex == false && me.columnx.length == 1) {
					me.$set(me.columnx[0], 'autoResize', true);
				}
				me.$nextTick(() => {
					let header = me.$refs.header;
					if (header) {
						//header.style.minHeight =
						//header.firstElementChild.offsetHeight + 1 + 'px !important';
						let newHeight = header.firstElementChild.offsetHeight + 1 + 'px';
						header.style.setProperty('min-height', newHeight, 'important');

						//Bug firefox 418919
						let browserInfo = me.$ms.commonFunc.getBrowserInfo();
						if (browserInfo && browserInfo.isFirefox) {
							me.setStyleHeaderForBrowerFirefox(header);
						}
					} else {
						let noContent = document.getElementsByClassName(
							'ms-header-nocontent'
						)[0];
						if (noContent) {
							noContent.style.setProperty('min-height', '32px', 'important');
							noContent.style.setProperty('height', '32px', 'important');
						}
					}
				});
			});
		},

		setStyleHeaderForBrowerFirefox(header) {
			const me = this;
			if (!header) return;
			let maxHeight = header.firstElementChild.offsetHeight + 1;
			let msThTitle = header.getElementsByClassName('ms-th-title');
			if (msThTitle && msThTitle.length > 0) {
				msThTitle.forEach((element) => {
					let height = element.offsetHeight; // Lấy chiều cao của mỗi phần tử
					if (height > maxHeight) {
						maxHeight = height;
					}
				});
			}
			header.style.setProperty('min-height', maxHeight + 2 + 'px', 'important');
			header.style.setProperty('height', maxHeight + 2 + 'px', 'important');
			let msThead = document.getElementsByClassName('ms-thead');
			if (msThead && msThead.length > 0) {
				msThead.forEach((element) => {
					element.style.setProperty(
						'min-height',
						maxHeight + 1 + 'px',
						'important'
					);
					element.style.setProperty(
						'height',
						maxHeight + 1 + 'px',
						'important'
					);
				});
			}
		},

		//Xóa 1 phần tử trong data grid
		removeItem(item) {
			const me = this;
			me.datax = _.remove(me.datax, (e) => {
				return e !== item;
			});
		},

		/**
		 * Gán giá trị để render data có thể truyền từ ngoài vào
		 */
		initData(data = this.data) {
			const me = this;
			me.internalDataSource = null;
			if (data) {
				me.internalDataSource = [...data];
			}
			//Nếu thực hiện lấy data dưới local thì thức hiện lưu dữ liệu vào internalDataSource và phân trang local
			if (me.queryMode == 'local' && me.pagination) {
				commonFunc.genVKeyValue(me.internalDataSource);
				me.datax = me.getItemPagination();
			} else {
				//Lấy dữ liệu từ server
				//Tạm gán = props data sau gán = gì khác tính sau
				me.datax = [...me.internalDataSource];
				commonFunc.genVKeyValue(me.datax);
			}
			if (me.isMasterDetail) {
				me.datax = me.$ms.commonFunc.getBodyData(
					me.datax,
					true,
					1,
					me.detailField
				);
			}
			me.$nextTick(() => {
				this.checkHasScroll();
				me.initColumns();
			});
		},

		/**
		 * Gán giá trị filter truyền từ ngoài vào grid để hiển thị lọc theo các column
		 */
		initFilterGrids(filterGrids = this.filterGrids) {
			const me = this;
			if (filterGrids) {
				filterGrids.forEach((item) => {
					//Gán giá trị
					let check = me.filterHeaders.find(
						(x) => x.FieldName == item.FieldName
					);
					if (check) {
						check.Value = item.Value;
						check.ValueText = item.ValueText;
					} else {
						me.filterHeaders.add(item);
					}
					//Gán cờ hiển thị button lọc cột
					//Kiểm tra đã render xong code thì mới xử lý tìm th
					if (me.$refs && me.$refs.th) {
						let th = me.$refs.th.find((x) => x.col.dataField == item.FieldName);
						if (th != null) {
							th.showOption = true;
							th.col.hasActionFilter = true;
						}
					}
				});
			}
		},

		//Lấy dữ liệu của dòng được chọn
		//Created by LTDAT(16.06.2020)
		getRowSelected() {
			const me = this;
			return me.rowSelected;
		},
		//Xử lý sự kiện ấn phím trên row
		//Created by LTDAT(15.06.2020)
		row_keydown(dataRow, e) {
			const me = this;
			let currentIndex = me.rowSelected.index;
			switch (e.which) {
				case 40: //down
					if (currentIndex < me.datax.length - 1 && !e.altKey) {
						currentIndex++;
						event.target.focus();
						me.rowSelected.data = me.datax[currentIndex];
						me.rowSelected.index = currentIndex;
						e.preventDefault();
					}
					break;
				case 38: //up
					if (currentIndex > 0 && !e.altKey) {
						currentIndex--;
						event.target.focus();
						me.rowSelected.data = me.datax[currentIndex];
						me.rowSelected.index = currentIndex;
						e.preventDefault();
					}
					break;
			}
		},
		clickPage() {
			const me = this;
			if (me.$refs.th && me.sortCol) {
				for (let i = 0; i < me.$refs.th.length; i++) {
					if (me.$refs.th[i].sortStatus != me.$ms.enum.SortStatus.none) {
						me.sort(me.columnx[i], me.$refs.th[i].sortStatus);
						return;
					}
				}
			}
		},

		resetDataAllSelected() {
			const me = this;
			me.dataAll = [];
		},
		/**
		 * Cập nhật dữ liệu chọn trên ds
		 */
		setDataAllSelected(lstData) {
			const me = this;
			me.dataAll = lstData;
			me.$emit('input', me.dataAll);
		},
		onClickiconAfterTitle() {
			const me = this;
			me.$emit('onClickiconAfterTitle');
		},

		/**
		 * Gán filter mặc định cho column
		 */
		setDefaultFilter(column) {
			const me = this;
			column.filter = {
				value: null,
				operator: me.setOperatorDefault(column.formatType),
			};

			switch (column.columnType) {
				case 'ColumnText':
				case 'ColumnDrilldown':
					if (!column.enumName || column.enum) {
						column.filter.operator = me.$ms.enum.FilterOperator.Contains;
					}
					break;
			}
		},

		/**
		 * hàm xóa 1 item filter lọc
		 * isUnfilter: Cờ đánh dấu đi từ chức năng bỏ lọc trên cột thì sẽ không emit nữa
		 */
		removeFilterItem(item, isUnfilter = false) {
			let me = this;
			//Nếu item truyền vào là loại col thì sẽ có dataField
			let isCol = item.dataField;
			if (isCol) {
				me.filterHeaders.remove(
					me.filterHeaders.find((x) => x.FieldName === item.dataField)
				);
			} else {
				me.filterHeaders.remove(
					me.filterHeaders.find((x) => x.FieldName === item.FieldName)
				);
			}
			let th = me.$refs.th.filter(
				(x) => x.col.dataField == (isCol ? item.dataField : item.FieldName)
			);
			if (th && th.length > 0) {
				th[0].col.filter.value = null;
				th[0].col.filter.operator = me.setOperatorDefault(th[0].col.formatType);
				th[0].col.hasActionFilter = false;
				th[0].checkHideButtonHeaderFilter();
			}
			if (!isUnfilter) me.$emit('loadFilterHeader', item);
		},

		/**
		 * hàm conver toán tử thành text: ví dụ "Contants" -> "Chứa"
		 */
		buildOperatorText(operator) {
			let operatorText = this.$ms.commonFunc.getDataFromEnumExactly(
				'FilterOperator',
				operator
			);
			if (operatorText) {
				operatorText = operatorText[0].display.toLocaleLowerCase();
			}
			return operatorText;
		},

		/**
		 * hàm build value filter
		 */
		buildValue(item) {
			let me = this;
			if (
				item.Operator == me.$ms.enum.FilterOperator.IsNull ||
				item.Operator == me.$ms.enum.FilterOperator.IsNotNull
			) {
				return '';
			}
			return '"' + item.ValueText + '"';
		},

		/**
		 * Build ra title
		 */
		buildTitleText(item) {
			let me = this;
			let text = me.$t(
				`${me.customGridLayout.i18n}.${me.customGridLayout.layoutID}`
			)[`${item.FieldName}`];
			if (isNullOrEmpty(text)) return item.Title;
			else return text;
		},

		/**
		 * lưu tất cả các cột đã đánh dấu là đang filter
		 */
		buildFilterHeader(col) {
			let me = this;
			let valueText = '';
			let isFilterAll = false; //Cờ đánh dấu lọc enum là tất cả thì sẽ xóa bộ lọc đi
			switch (col.formatType) {
				case me.$ms.enum.FormatType.Enum:
					//Kiểm tra giá trị làm array không?
					let isArray = Array.isArray(col.filter.value);
					if (isArray) {
						valueText = col.filter.value
							.map((x) =>
								me.$options.filters.formatData(x.value, {
									formatType: col.formatType,
									enumName: col.enumName,
								})
							)
							.join(', ');
						if (
							col.filter.value.length == 1 &&
							col.filter.value[0].value == me.$ms.enum[col.enumName].All
						) {
							isFilterAll = true;
						}
					} else {
						valueText = me.$options.filters.formatData(col.filter.value, {
							formatType: col.formatType,
							enumName: col.enumName,
						});
					}
					break;
				case me.$ms.enum.FormatType.EnumOne:
					valueText = me.$options.filters.formatData(col.filter.value, {
						formatType: col.formatType,
						enumName: col.enumName,
					});
					if (col.filter.value == me.$ms.enum[col.enumName].All) {
						isFilterAll = true;
					}
					break;
				case me.$ms.enum.FormatType.Date:
					if (col.filter.operator == me.$ms.enum.FilterOperator.Between) {
						valueText = `${me.$options.filters.formatData(col.filter.from, {
							formatType: col.formatType,
						})} - ${me.$options.filters.formatData(col.filter.to, {
							formatType: col.formatType,
						})}`;
					} else {
						valueText = me.$options.filters.formatData(col.filter.value, {
							formatType: col.formatType,
						});
					}
					break;
				case me.$ms.enum.FormatType.Number:
					valueText = me.$options.filters.formatData(col.filter.value, {
						formatType: col.formatType,
						maxDigits: 2,
					});
					break;
				default:
					valueText = col.filter.value;
					break;
			}
			//Nếu TH là enum mà giá trị chọn lọc là tất cả thì sẽ không xử lý
			if (isFilterAll) {
				let check = me.filterHeaders.find((i) => i.FieldName == col.dataField);
				if (check != null) {
					me.removeFilterItem(check);
				}
			} else {
				me.processFilterHeader(
					col.dataField,
					col.filter.operator,
					col.filter.value,
					valueText,
					col.filter.from,
					col.filter.to
				);
				let th = me.$refs.th.filter((x) => x.col.dataField == col.dataField);
				if (th && th.length > 0) {
					th[0].checkHideButtonHeaderFilter();
				}
			}
		},

		/**
		 * Xử lý thêm hoặc update giá trị vào FilterHeader
		 */
		processFilterHeader(
			fieldName,
			operator,
			value,
			valueText,
			from = null,
			to = null
		) {
			const me = this;
			let newFilter = {
				FieldName: fieldName,
				Operator: operator,
				Value: value,
				ValueText: valueText,
				FromDate: from,
				ToDate: to,
				Title: me.$t(`i18nComponent.HeaderOptionFilter.${fieldName}`),
			};
			//Kiểm tra đã tồn tại thì gán lại giá trị không thì sẽ thêm mới bộ lọc
			let check = me.filterHeaders.find((i) => i.FieldName == fieldName);
			if (check == null) {
				me.filterHeaders.push(newFilter);
			} else {
				check.Operator = operator;
				check.Value = value;
				check.ValueText = valueText;
				check.FromDate = from;
				check.ToDate = to;
			}
		},

		/**
		 * hàm bỏ lọc cột
		 */
		clearAllFilter() {
			let me = this;
			me.filterHeaders.forEach((item) => {
				if (
					!item.FormatType ||
					item.FormatType == me.$ms.enum.FormatType.Text ||
					item.FormatType == me.$ms.enum.FormatType.None
				) {
					item.Operator = me.$ms.enum.FilterOperator.Contains;
				} else {
					item.Operator = me.$ms.enum.FilterOperator.Equals;
				}
				let th = me.$refs.th.filter((x) => x.col.dataField == item.FieldName);
				if (th && th.length > 0) {
					th[0].col.filter.value = null;
					th[0].col.filter.operator = me.setOperatorDefault(
						th[0].col.formatType
					);
					th[0].col.hasActionFilter = false;
					th[0].checkHideButtonHeaderFilter();
				}
			});
			me.filterHeaders.removeAll();
			me.$emit('loadFilterHeader', null);
		},

		/**
		 * Set operator mặc định của các cột
		 */
		setOperatorDefault(formatType) {
			const me = this;
			if (formatType == me.$ms.enum.FormatType.Enum) {
				return me.$ms.enum.FilterOperator.In;
			} else if (formatType == me.$ms.enum.FormatType.EnumOne) {
				return me.$ms.enum.FilterOperator.Equals;
			} else if (
				formatType == me.$ms.enum.FormatType.Number ||
				formatType == me.$ms.enum.FormatType.Date
			) {
				return me.$ms.enum.FilterOperator.Equals;
			} else {
				return me.$ms.enum.FilterOperator.Contains;
			}
		},

		resetPageSize(pageSize, isLoadPage = true) {
			try {
				const me = this;
				me.pageSize = pageSize;
				me.$refs.pagination.setPageSize(pageSize);
				if (isLoadPage) {
					me.$refs.pagination.loadPageIndex(1);
				}
			} catch (ex) {
				console.log(ex);
			}
		},

		/**
		 * Hàm load lại tổng số trang ở trang hiện tại
		 * @author hvanh - 17.6.2024
		 */
		reloadCurrentPageSize(pageSize, isLoadPage = true) {
			try {
				const me = this;
				me.pageSize = pageSize || me.pageSize;
				me.$refs.pagination.setPageSize(pageSize);
				if (isLoadPage) {
					me.$refs.pagination.loadPageIndex(me.currentPage);
				}
			} catch (ex) {
				console.log(ex);
			}
		},
	},
	data() {
		const me = this;
		return {
			//Data trong grid dùng để render
			datax: null,
			//Columns trong grid dùng để render
			columnx: [],
			//Mode cho phép copy dữ liệu hay không thực hiện với các event kéo thả cột,độ rộng,...
			isResizeActive: false,
			//Trang hiện tại
			currentPage: 1,
			//Số bản ghi trên 1 trang
			pageSize: me.$ms.commonFunc.getTakePageSize(),
			//Dòng đang được chọn
			rowSelected: {},
			//Kiểm tra data đã được load hay chưa
			dataLoaded: false,
			hasScroll: false,
			isScrollLeft: false,
			layoutId: '',
			/**
			 * Dữ liệu tích chọn của nhiều trang danh sách các object
			 * {pageIndex : 0, datax : []}
			 */
			dataAll: [],
			//Filter trong grid dùng để render
			filterHeaders: [],
			isScreenMall: this.$ms.commonFunc.checkSmallScreen(),
		};
	},
	beforeDestroy() {
		const me = this;
		document.removeEventListener('click', me.clickOutGrid);
		window.removeEventListener('resize', me.onResize);
		EventBusGlobal.$off(GlobalEventName.ResizeMsThGroup, me.updateScroll);
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msgridviewer/msGridViewerV2.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msgridviewer/msGridViewerV2.scss';
}
.multiple-cell-widget {
	position: sticky;
	left: 35px;
}
.icon-attachfile {
	padding: 0px !important;
}

.text-orgempty-setting {
	color: #bec5d2;
	font-size: 14px;
	width: 170px;
}

.data-field {
	min-width: 100px;
}
.item-filter {
	max-width: 100%;
}
/deep/.ms-tr .widget-item {
	border-left: none;
}

/deep/.ms-tr .widget-item .option-menu-invoice {
	display: none;
}

/deep/.ms-tr:hover .widget-item .option-menu-invoice {
	display: flex;
}
.icon-area {
	display: flex;
	justify-content: center;
	align-items: center;
}
.text-nondata-area {
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 18px;
}
</style>
